/* eslint-disable */
export const customerlyInit = () => {
  const customerly = (window.customerly = window.customerly || [])
  if (customerly.initialized) {
    return console.error(
      '[customerly] SDK already initialized. Snippet included twice.'
    )
  }
  customerly.initialized = true
  customerly.loaded = false

  const getFakeMethod = function (method) {
    return function (...args) {
      args.unshift(method)
      customerly.queue.push(args)
      return customerly
    }
  }

  customerly.queue = []
  const methods = [
    'event',
    'attribute',
    'update',
    'show',
    'hide',
    'open',
    'close',
  ]
  methods.forEach(function (method) {
    customerly[method] = getFakeMethod(method)
  })

  customerly.load = function (settings) {
    customerly.settings = settings || {}
    if (customerly.loaded) {
      return console.error(
        '[customerly] SDK already loaded. Use customerly.update to change settings.'
      )
    }
    customerly.loaded = true

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = 'https://messenger.customerly.io/launcher.js'

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(script, firstScript)
  }
}
